<table  style="margin: 10px; width:95%;" class="table table-striped table-hover" data-row-style="rowStyle">
    <thead>
      <tr class="t-header">
        <th class="" scope="col">
          <div  class="actionPadding" title="Name">Name</div>
        </th>
        <th class="" scope="col">
          <div title="Type">Poll Type</div>
        </th>
        <th class="" scope="col">
          <div title="Date">Date </div>
        </th>
        <th class="" scope="col">
            <div title="Result">Poll Result </div>
        </th>
        <th class="" scope="col">
            <div title="View Result">View Result </div>
        </th>
      </tr>
    </thead>
    <tbody>
        <tr *ngFor="let data of testData let indexOfelement=index;">
          <td>
              {{data.Name | titlecase}}
          </td>
          <td>
              {{data.Type | titlecase}}
          </td>
          <td>
              {{data.Date}}
          </td>
          <td>
            {{data.Result}}
          </td>
          <td>
            <button (click)= "openDialog()" mat-raised-button style="height: 2rem;">View</button>
          </td>

        
        </tr>
    </tbody>
</table>